module.exports = __webpack_public_path__ + "img/ico_share--black.23680c59.svg";